import { ClipboardModule } from "@angular/cdk/clipboard";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EffectsModule } from "@ngrx/effects";
import { StoreRouterConnectingModule, routerReducer } from "@ngrx/router-store";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { AccountAuthDataAccessModule } from "@youm-front/account-auth/data-access";
import {
  ACCOUNT_JWT_CONFIG,
  AccountJwtDataAccessModule
} from "@youm-front/account-jwt/data-access";
import { AccountDataAccessModule } from "@youm-front/account/data-access";
import { ApiDataAccessModule } from "@youm-front/api/data-access";
import { Conf2DataAccessModule } from "@youm-front/conf2/data-access";
import { DevToolsDataAccessModule } from "@youm-front/dev-tools/data-access";
import { IAM_ACCOUNT_CONFIG } from "@youm-front/iam-account/data-access";
import { IAMAccountFeaturePasswordUpdateModule } from "@youm-front/iam-account/feature/password-update";
import { KEYCLOAK_CONFIG } from "@youm-front/keycloak/data-access";
import {
  LOKI_CONFIG,
  LokiDataAccessModule
} from "@youm-front/loki/data-access";
import { NoticeDataAccessModule } from "@youm-front/notice/data-access";
import { NoticeFeatureNoticeModule } from "@youm-front/notice/feature/notice";
import { UiSvgModule } from "@youm-front/ui-svg";
import { ErrorHandlerModule } from "@youm-front/utils/error-handler";
import { runtimeEnvironment } from "../runtime-environments/runtime-environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import Guards from "./guards";

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    ClipboardModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    StoreModule.forRoot({
      router: routerReducer
    }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25
    }),
    AccountJwtDataAccessModule,
    AccountAuthDataAccessModule,
    AccountDataAccessModule.forRoot({
      noAuthRedirectToUrl: runtimeEnvironment.noAuthRedirectToURL
    }),
    ApiDataAccessModule.forRoot({
      serverUrl: runtimeEnvironment.serverURL
    }),
    DevToolsDataAccessModule,
    ErrorHandlerModule,
    IAMAccountFeaturePasswordUpdateModule,
    LokiDataAccessModule,
    NoticeDataAccessModule,
    NoticeFeatureNoticeModule,
    UiSvgModule,
    Conf2DataAccessModule,
    AppRoutingModule
  ],
  providers: [
    {
      provide: KEYCLOAK_CONFIG,
      useValue: runtimeEnvironment.keycloak
    },
    {
      provide: IAM_ACCOUNT_CONFIG,
      useValue: runtimeEnvironment.iamAccount
    },
    {
      provide: LOKI_CONFIG,
      useValue: { container: "youm-front" }
    },
    {
      provide: ACCOUNT_JWT_CONFIG,
      useValue: {
        domain: runtimeEnvironment.domain,
        name: runtimeEnvironment.tokenName
      }
    },
    Guards
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
